import React from 'react';
import CardTooltip from './Card.Tooltip';
import './Card.Widget.css';

export default function CardWidget({ className = '', children, tooltip = null, ...props }) {
  return (
    <div className={`${className} card-widget-wrapper`} {...props}>
      {tooltip && (
        <div className="card-widget-info">
          <CardTooltip content={tooltip} position="right">
            <WidgedIconButton Icon={InfoIcon} />
          </CardTooltip>
        </div>
      )}
      {children}
    </div>
  );
}

function WidgedIconButton({ Icon }) {
  return (
    <button
      type="button"
      style={{
        display: 'flex',
        border: 'none',
        width: 'max-content',
        height: 'max-content',
        background: 'transparent',
      }}
    >
      <Icon />
    </button>
  );
}

function InfoIcon() {
  return (
    <svg data-icon="small-info-sign" width="16" height="16" fill="#787878" viewBox="0 0 16 16" role="img">
      <path d="M14 8A6 6 0 112 8a6 6 0 0112 0zM9 4v2H7V4h2zm0 3v4h1v1H6v-1h1V8H6V7h3z" fillRule="evenodd" />
    </svg>
  );
}
